<template>
  <section class="flex justify-center">
    <div class="w-full max-w-md py-8 px-4">
      <div class="mb-6 text-center">
        <h2 class="text-2xl font-bold mb-2">Identificação</h2>
        <p class="text-sm text-gray-600">
          {{ identificationText }}
        </p>
      </div>

      <form @submit.prevent="handleSubmit" class="space-y-4">
        <!-- Campo de Email -->
        <i-email
          v-if="fieldType === 'email'"
          v-model="identificationValue"
          label="E-mail"
          placeholder="seu@email.com"
          :is-required="true"
          :submitted="submitted"
        />

        <!-- Campo de CPF -->
        <i-cpf
          v-else-if="fieldType === 'cpf'"
          v-model="identificationValue"
          label="CPF"
          placeholder="000.000.000-00"
          :is-required="true"
          :submitted="submitted"
        />

        <!-- Mensagem de erro -->
        <div
          v-if="error"
          class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm"
        >
          {{ error }}
        </div>

        <!-- Mensagem de aviso -->
        <div class="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-md text-sm">
          <p class="font-medium mb-1">Por que precisamos disso?</p>
          <p v-if="fieldType === 'email'">
            Utilizamos seu e-mail para identificá-lo e enviar informações importantes sobre o evento.
          </p>
          <p v-else>
            Utilizamos seu CPF para identificá-lo de forma segura e validar sua inscrição.
          </p>
        </div>

        <!-- Botão de submit -->
        <button
          type="submit"
          :disabled="loading || !identificationValue"
          class="w-full button-subs text-white px-4 py-3 rounded-md font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="loading">Verificando...</span>
          <span v-else>Continuar</span>
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { ref, computed } from 'vue';
import IEmail from '@/components/inputs/i-email.vue';
import ICpf from '@/components/inputs/i-cpf.vue';

export default {
  name: 'IdentificationStep',
  components: {
    IEmail,
    ICpf
  },
  props: {
    fieldType: {
      type: String,
      default: 'email',
      validator: (value) => ['email', 'cpf'].includes(value)
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit'],
  setup(props, { emit }) {
    const identificationValue = ref('');
    const loading = ref(false);
    const error = ref(null);

    const identificationText = computed(() => {
      if (props.fieldType === 'email') {
        return 'Digite seu e-mail para iniciar o cadastro ou recuperar seus dados.';
      } else {
        return 'Digite seu CPF para iniciar o cadastro ou recuperar seus dados.';
      }
    });

    const handleSubmit = () => {
      if (!identificationValue.value) {
        error.value = `Por favor, preencha seu ${props.fieldType === 'email' ? 'e-mail' : 'CPF'}.`;
        return;
      }

      error.value = null;
      emit('submit', identificationValue.value);
    };

    return {
      identificationValue,
      loading,
      error,
      identificationText,
      handleSubmit
    };
  }
};
</script>
